// extracted by mini-css-extract-plugin
module.exports = {"lia-container":"PageError_lia-container__z6RBk"};